import { Component, Input } from '@angular/core';
import { CheatSheetContentType } from '@app/modules/cheat-sheet/models/cheat-sheet-content.type';

@Component({
    selector: 'fdx-cheat-sheet-panel-content',
    templateUrl: './cheat-sheet-panel-content.component.html',
    styleUrl: './cheat-sheet-panel-content.component.scss',
    standalone: false
})
export class CheatSheetPanelContentComponent {
    @Input() data: CheatSheetContentType;
}
